export const insertContractForm = async (
  user,
  estimateHeader,
  estimateInfo
) => {
  var data = JSON.stringify({
    docID: makeid(5),
    latestVersion: 1,
    formID: 1,
    userID: user.userID,
    submitDate: new Date(),
    header: estimateHeader,
    info: estimateInfo,
    user: user,
  });

  const rawResponse = await fetch("/api/forms/misc/addContract", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const insertEditedContractForm = async (
  user,
  estimateHeader,
  estimateInfo,
  docID
) => {
  var data = JSON.stringify({
    docID: docID,
    latestVersion: 1,
    formID: 1,
    userID: user.userID,
    submitDate: new Date(),
    header: estimateHeader,
    info: estimateInfo,
    user: user,
  });

  const rawResponse = await fetch("/api/forms/misc/editContract", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const sendContractPDF = async (emailData) => {
  //console.log(emailData[0]);

  var data = JSON.stringify(emailData);
  const rawResponse = await fetch("/api/forms/misc/sendContract", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const getContract = async (setter, docID) => {
  return fetch(`/api/forms/misc/getContract?docID=${docID}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson[0]);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const importQuote = async (setter, quote) => {
  return fetch(`/api/forms/misc/importQuote?QuoteNumber=${quote}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson.recordsets[0]);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllContracts = async (setter, user) => {
  // Pages can mount before login finishes; skip until the user is ready.
  if (!user?.userID) return;
  return fetch(`/api/forms/misc/getAllContracts?user=${user.userID}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const makeid = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getDrafts = async (setter, user) => {
  // Pages can mount before login finishes; skip until the user is ready.
  if (!user?.userID) return;
  return fetch(`/api/forms/misc/getDrafts?user=${user.userID}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllInteriorDoorEntries = async (setter) => {
  return fetch(`/api/forms/misc/getForms/interiordoororders`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllRecognitions = async (setter) => {
  return fetch(`/api/forms/misc/getForms/recognition`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getForms = async (setter, user) => {
  // Pages can mount before login finishes; skip until the user is ready.
  if (!user?.userID) return;
  return fetch(`/api/forms/misc/getForms?user=${user.userID}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getWindowForms = async (
  setter,
  salesUserId = null,
  assignedUserId = null
) => {
  const params = new URLSearchParams();
  if (salesUserId) {
    params.append("salesUserId", salesUserId);
  }
  if (assignedUserId) {
    params.append("assignedUserId", assignedUserId);
  }
  const query = params.toString() ? `?${params.toString()}` : "";
  return fetch(`/api/forms/misc/windowforms${query}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getWindowFormDetail = async (setter, id) => {
  return fetch(`/api/forms/misc/windowforms/${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getWindowFormMessages = async (setter, id, channel = "internal") => {
  return fetch(`/api/forms/misc/windowforms/${id}/messages?channel=${channel}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const postWindowFormMessage = async (
  id,
  payload,
  channel = "internal"
) => {
  const rawResponse = await fetch(
    `/api/forms/misc/windowforms/${id}/messages?channel=${channel}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );
  return rawResponse.json();
};

export const postWindowFormQuote = async (id, payload, channel = "shared") => {
  const rawResponse = await fetch(
    `/api/forms/misc/windowforms/${id}/quotes?channel=${channel}`,
    {
      method: "POST",
      body: payload,
    }
  );
  return rawResponse.json();
};

export const updateWindowFormStatus = async (id, payload) => {
  const rawResponse = await fetch(`/api/forms/misc/windowforms/${id}/status`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return rawResponse.json();
};

export const updateWindowFormEntry = async (id, payload) => {
  const rawResponse = await fetch(`/api/forms/misc/windowforms/${id}/revision`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return rawResponse.json();
};

export const getWindowFormNotificationSettings = async (setter) => {
  return fetch(`/api/forms/misc/windowforms/notifications`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const updateWindowFormNotificationSettings = async (payload) => {
  const rawResponse = await fetch(`/api/forms/misc/windowforms/notifications`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return rawResponse.json();
};

export const getWindowFormDefinitions = async (setter) => {
  return fetch(`/api/forms/misc/windowforms/definitions`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

// Promise-returning variant of getWindowFormDefinitions. The setter-only
// version never calls back on failure, which would leave the RFQ form picker
// spinning forever instead of offering a retry.
export const fetchWindowFormDefinitions = async () => {
  const response = await fetch(`/api/forms/misc/windowforms/definitions`);
  if (!response.ok) {
    throw new Error(`Window form definitions failed (${response.status})`);
  }
  return (await response.json()) || [];
};

export const getWindowFormDefinition = async (setter, formId) => {
  return fetch(`/api/forms/misc/windowforms/definitions/${formId}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const updateWindowFormDefinition = async (formId, payload) => {
  const rawResponse = await fetch(
    `/api/forms/misc/windowforms/definitions/${formId}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );
  return rawResponse.json();
};

export const deleteWindowFormDefinition = async (formId) => {
  const rawResponse = await fetch(
    `/api/forms/misc/windowforms/definitions/${formId}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  return rawResponse.json();
};
